"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _popover = _interopRequireDefault(require("antd/lib/popover"));

var _drawer = _interopRequireDefault(require("antd/lib/drawer"));

var _Sensor = _interopRequireDefault(require("@meepshop/context/lib/Sensor"));

var _previewer = _interopRequireDefault(require("./previewer"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// typescript import
// import
require("./styles/index.less");

var styles = {
  "popover": "store-cart-previewer__index__popover",
  "drawer": "store-cart-previewer__index__drawer"
}; // typescript definition

// definition
var _default = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var children = _ref.children,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["children"]);

  var _useContext = (0, _react.useContext)(_Sensor["default"]),
      isMobile = _useContext.isMobile;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var onClose = (0, _react.useCallback)(function () {
    return setIsOpen(false);
  }, [setIsOpen]);
  if (isMobile) return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].cloneElement(children, {
    onClick: function onClick() {
      return setIsOpen(true);
    }
  }), /*#__PURE__*/_react["default"].createElement(_drawer["default"], {
    className: styles.drawer,
    placement: "left",
    width: "80%",
    closable: false,
    destroyOnClose: true,
    visible: isOpen,
    onClose: onClose
  }, /*#__PURE__*/_react["default"].createElement(_previewer["default"], (0, _extends2["default"])({}, props, {
    onClose: onClose
  }))));
  return /*#__PURE__*/_react["default"].createElement(_popover["default"], {
    placement: "bottomRight",
    trigger: "hover",
    overlayClassName: styles.popover,
    content: /*#__PURE__*/_react["default"].createElement(_previewer["default"], (0, _extends2["default"])({}, props, {
      onClose: onClose
    }))
  }, children);
});

exports["default"] = _default;